import { SVGProps } from "react";

export function NotificationsIllustration(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width={88} height={88} viewBox="0 0 88 88" fill="none" {...props}>
      <circle cx={48} cy={36} r={24} fill="#DEDFE0" opacity={0.2} />
      <rect width={44} height={16} x={8} y={46} fill="#AACFD3" rx={2} />
      <rect
        width={22}
        height={3}
        x={12}
        y={50}
        fill="#fff"
        opacity={0.9}
        rx={1.5}
      />
      <rect
        width={36}
        height={3}
        x={12}
        y={55}
        fill="#fff"
        opacity={0.6}
        rx={1.5}
      />
      <rect width={44} height={16} x={8} y={26} fill="#AACFD3" rx={2} />
      <rect
        width={22}
        height={3}
        x={12}
        y={30}
        fill="#fff"
        opacity={0.9}
        rx={1.5}
      />
      <rect
        width={36}
        height={3}
        x={12}
        y={35}
        fill="#fff"
        opacity={0.6}
        rx={1.5}
      />
      <path
        fill="#3E8D96"
        d="M43.113 65.513c-.593 0-1.093-.199-1.501-.597A1.965 1.965 0 0 1 41 63.453c0-.578.204-1.066.612-1.464.408-.397.908-.596 1.501-.596h1.724V49.116c0-2.606.795-4.926 2.384-6.96 1.589-2.033 3.666-3.362 6.232-3.988v-1.203c0-.826.294-1.527.884-2.102.59-.575 1.31-.863 2.157-.863.849 0 1.568.288 2.157.863.59.575.885 1.276.885 2.102v1.203c2.574.626 4.653 1.955 6.238 3.989 1.585 2.033 2.377 4.353 2.377 6.96v12.276h1.736c.593 0 1.093.199 1.501.596.408.398.612.886.612 1.464s-.204 1.066-.612 1.463c-.408.398-.908.597-1.501.597H43.113ZM56.506 71c-1.06 0-1.965-.365-2.719-1.097-.753-.73-1.13-1.612-1.13-2.644h7.686c0 1.032-.375 1.914-1.125 2.644-.75.731-1.654 1.097-2.712 1.097Z"
      />
    </svg>
  );
}
